import { schema, t, type SchemaType } from "@colyseus/schema";

export const EntityStateSchema = schema(
  {
    id: t.string(),
    entityType: t.string(),
    persistentId: t.string(),
    monsterId: t.string(),
    spawnSlotId: t.string(),
    ownerId: t.string(),
    name: t.string(),
    appearanceId: t.string(),
    x: t.number(),
    y: t.number(),
    direction: t.uint8(),
    animation: t.string(),
    statusEffects: t.string(),
    guardUntil: t.number(),
    guardAttackerId: t.string(),
    guardDamageReduction: t.number(),
    counterReadyUntil: t.number(),
    counterTargetId: t.string(),
    hp: t.number(),
    maxHp: t.number(),
    chakra: t.number(),
    maxChakra: t.number(),
    team: t.uint8(),
    alive: t.boolean(),
  },
  "EntityState",
);
export type EntityState = SchemaType<typeof EntityStateSchema>;

export const ParticipantStateSchema = schema(
  {
    username: t.string(),
    team: t.uint8(),
    online: t.boolean(),
  },
  "ParticipantState",
);
export type ParticipantState = SchemaType<typeof ParticipantStateSchema>;

export const TechniqueFieldStateSchema = schema(
  {
    id: t.string(),
    sourceId: t.string(),
    techniqueId: t.string(),
    techniqueLevel: t.uint8(),
    x: t.number(),
    y: t.number(),
    radius: t.number(),
    expiresAt: t.number(),
    nextPulseAt: t.number(),
    pulseIndex: t.uint8(),
    pulseCount: t.uint8(),
    pulseIntervalMs: t.number(),
  },
  "TechniqueFieldState",
);
export type TechniqueFieldState = SchemaType<typeof TechniqueFieldStateSchema>;

export const TechniqueShieldStateSchema = schema(
  {
    id: t.string(),
    sourceId: t.string(),
    targetId: t.string(),
    techniqueId: t.string(),
    shieldKey: t.string(),
    amount: t.number(),
    appliedAmount: t.number(),
    visualEffectId: t.uint16(),
    expiresAt: t.number(),
  },
  "TechniqueShieldState",
);
export type TechniqueShieldState = SchemaType<
  typeof TechniqueShieldStateSchema
>;

export const InstanceStateSchema = schema(
  {
    instanceId: t.string(),
    mapId: t.string(),
    mapRevision: t.string(),
    mode: t.string(),
    phase: t.string(),
    elapsedMs: t.number(),
    matchLimitMs: t.number(),
    eventSequence: t.uint32(),
    entities: t.map(EntityStateSchema),
    participants: t.map(ParticipantStateSchema),
    techniqueFields: t.map(TechniqueFieldStateSchema),
    shields: t.map(TechniqueShieldStateSchema),
  },
  "InstanceState",
);
export type InstanceState = SchemaType<typeof InstanceStateSchema>;
